import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrPasswordComponent } from './tr-password.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
    ],
    exports: [ TrPasswordComponent ],
    declarations: [ TrPasswordComponent ],
})
export class TrPasswordModule {}
